export default "__VITE_ASSET__DV2maYEg__"